"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreenOffsetColorTransform = void 0;
var tslib_1 = require("tslib");
var color_1 = require("@devexpress/utils/lib/utils/color");
var dx_color_1 = require("../../color/dx-color");
var color_transform_value_base_1 = require("./color-transform-value-base");
var GreenOffsetColorTransform = (function (_super) {
    tslib_1.__extends(GreenOffsetColorTransform, _super);
    function GreenOffsetColorTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GreenOffsetColorTransform.prototype.clone = function () {
        return new GreenOffsetColorTransform(this.value);
    };
    GreenOffsetColorTransform.prototype.applyTransform = function (color) {
        return dx_color_1.DXColor.fromRgb(color_1.ColorUtils.getRed(color), this.applyRGBOffset(color_1.ColorUtils.getGreen(color)), color_1.ColorUtils.getBlue(color));
    };
    return GreenOffsetColorTransform;
}(color_transform_value_base_1.ColorTransformValueBase));
exports.GreenOffsetColorTransform = GreenOffsetColorTransform;
